import React, { useState } from "react";
import { connect } from "react-redux";
import { useForm, ErrorMessage } from "react-hook-form";
import withSizes from 'react-sizes';
import clsx from 'clsx';

import { Container, Row, Col } from "deltoid/core/Blocks/BootstrapContainers";
import { Card } from "deltoid/core/OneDashCards";
import { H, Caption } from "deltoid/core/Blocks/Typography";
import Form from "deltoid/core/Form";

import SignUpCMS from "../../features/prismic/SignUpCMS";
import { setPassword } from '../../../shared/actions/auth';
import { 
    strongPasswordRegex,
    hasMinChars,
    hasUpperChar,
    hasLowerChar,
    hasNumber,
    hasSpecialChar,
  } from '../../../shared/services/validations';

import LoginIllustration from "../../../assets/svgs/loginIllustration.svg";
import PayUIcon from "../../../assets/svgs/PayU-Icon.svg";

const SetPassword = (props) => {

  const { register, handleSubmit, errors, getValues, setError, clearError } = useForm();
  const [passwordShown, setPasswordShown] = useState(false);
  const [open, setOpen] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState({
    hasMin8Chars: false,
    hasUppercaseChar: false,
    hasLowercaseChar: false,
    hasDigit: false,
    hasSpecialChar: false,
  })

  const onSubmit = async (formData) => {
    const params = {
        new_password: formData.password,
      };
      try {
        const setPasswordPromise = setPassword(props.dispatch, params);
        await Promise.all([setPasswordPromise]);
        props.history.push({
            pathname: "/account/setting-up",
            state: {
              ...props.location.state,
            },
          });
       
      } catch (e) {
          console.log(e);
      }
  };

  const validatePassword = e => {
    const { value } = e.target;
    const passwordStrength = {
      hasMin8Chars: hasMinChars(value, 8),
      hasUppercaseChar: hasUpperChar(value),
      hasLowercaseChar: hasLowerChar(value),
      hasDigit: hasNumber(value),
      hasSpecialChar: hasSpecialChar(value),
    };
    setPasswordStrength(passwordStrength);
  };

  const getTickIcon = (success) => {
    return (
      <div className={`checkmark ${success ? 'success' : ''}`}>
        <div className="checkmark_circle" />
        <div className="checkmark_stem" />
        <div className="checkmark_kick" />
      </div>
    );
  }

  const getValidationContent = () => {
    const {
      hasMin8Chars,
      hasUppercaseChar,
      hasLowercaseChar,
      hasDigit,
      hasSpecialChar,
    } = passwordStrength;
    return (
      <div className="password-checklist-wrapper">
        <ul className="password-list p-0">
          <li>{getTickIcon(hasMin8Chars)} atleast 8 characters</li>
          <li>{getTickIcon(hasUppercaseChar)} atleast 1 uppercase</li>
          <li>{getTickIcon(hasLowercaseChar)} atleast 1 lowercase</li>
          <li>{getTickIcon(hasDigit)} atleast 1 number</li>
          <li>{getTickIcon(hasSpecialChar)} atleast 1 special character</li>
        </ul>
      </div>
    );
  }

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  }

  const className = clsx(
    'tooltip-container',
    {
      'mobile': false,
      'hide': !open,
    },
  );

  return (
    <Container fluid className='vector-bg login-max-width-container'>
      <Row>
        {props.isMobile ?
            <Col md={12} className='p-0 d-flex justify-content-between grey-background login-illustration'>
              <span className='pt-4 px-4'><PayUIcon /></span>
              <LoginIllustration />
            </Col>
              :
            <Col md={6} className='p-0'>
              <SignUpCMS />
            </Col>
          }
        <Col md={5} className={props.isMobile && 'm-0 p-0'}>
          <div className={!props.isMobile && 'login-container mt-5 mx-4'}>
          <Card>
            <H level={5} variant="regular" className="co-heading worksansregular-font">
                Set Password
            </H>
            <Caption className='pt-3'>
                Please set a new password for your PayU account
            </Caption>
            <form onSubmit={handleSubmit(onSubmit)} className='px-3 py-3'>
                <Row>
                  <Form.Group className="position-relative pt-4 mb-3">
                    <Form.Label id="email">
                      Email
                    </Form.Label>
                    <Form.Text
                      id="email"
                      name="email"
                      type="text"
                      defaultValue={props.location.state.userEmail}
                      readOnly
                    />
                  </Form.Group>
                </Row>
                <Row className='why-btn'>
                  <Form.Group className="position-relative mb-3">
                    <Form.Label id="password" >
                      Set a Password
                    </Form.Label>
                    <Form.Text
                      id="password"
                      name="password"
                      type={passwordShown ? "text" : "password"}
                      ref={register({
                        required: "Password can not be empty",
                        validate: { regex: strongPasswordRegex },
                      })}
                      placeholder="New Password"
                      onFocus={() => setOpen(true)}
                      onBlur={() => setOpen(false)}
                      onChange={(e) => validatePassword(e)}
                      endAdornment={{ type: `${passwordShown ? 'view-disabled' : 'view-1'}`, color: 'default', onClick: () => togglePasswordVisiblity() }}
                    />
                    <div className={className}>
                      <Caption variant='bold' className='mb-2 text-dark'>Your password must have:</Caption>
                      <Caption className='text-dark'>{getValidationContent()}</Caption>
                   </div>
                    <ErrorMessage errors={errors} name="password">
                      {({ message }) => (
                        <Form.Message
                          type="error"
                        >
                          {message}
                        </Form.Message>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Row>
                <Row className="justify-content-end">
                  <Form.Button
                    type="submit"
                    className="w-100 mt-4 font-weight-bold rounded-btn"
                  >
                    Confirm & Go to Dashboard
                  </Form.Button>
                </Row>
                <Row className='pt-2'>
                  <Form.Group className="position-relative d-flex mb-3">
                    <Form.Label id="tnc" className='pt-3 px-3'>
                      By signing up, you agree to our 
                      {" "}
                      <a href={`${process.env.PAYU_WEBSITE_HOST}/tnc`} className="highlight" target="_blank">Terms & Conditions</a>
                      {" "}
                      and
                      {" "}
                      <a href={`${process.env.PAYU_WEBSITE_HOST}/privacy-policy`} className="highlight" target="_blank">Privacy Policy</a>
                    </Form.Label>
                  </Form.Group>
                </Row>
              </form>
          </Card>
          </div>
        </Col>
      </Row>
    </Container>
  );
};


const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

const mapStateToProps = (state) => {
  return {
  };
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
});


const Responsive = withSizes(mapSizesToProps)(SetPassword);
export default connect(mapStateToProps, mapDispatchToProps)(Responsive);